import {
	TakeoverBanner,
	TakeoverBannerProps,
} from '../../../../libraries/design/components/takeover-banner/src/takeover-banner';

const UniformTakeoverBanner = (props: TakeoverBannerProps) => {
	return (
		<TakeoverBanner
			{...props}
			dataEventProps={{
				'data-product-key': 'uniform',
				'data-event-component': 'linkButton',
				'data-event-container': 'takeoverBanner',
				'data-event': 'clicked',
			}}
		/>
	);
};

export default UniformTakeoverBanner;
